// Do not add new methods to this file.
// We want to remove duplicated logic and eventually remove this file.
import Cookies from 'js-cookie';

import { DatasourceService } from '@canvas/atlassian-service/datasource';
import { getServerIdFromCloudId } from '@canvas/atlassian-service/datasource/migration';

import { getParentWindow } from './context/DatabaseContentContext';

let cloudId: string | undefined;

let activationId: string | undefined;

/**
 * @deprecated Access this from the BridgeData instead.
 */
export const setCloudId = (newCloudId: string | undefined) => {
  cloudId = newCloudId;
};

/**
 * @deprecated Access this from the BridgeData instead.
 */
export const getCloudId = (): string | undefined => {
  if (cloudId) {
    return cloudId;
  }

  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('cloudId') ?? undefined;
};

export const getBaseUrl = (): string => {
  let baseUrl = window.location.origin;
  if (new URL(baseUrl).hostname.includes('localhost')) {
    const backendOrigin = Cookies.get('BACKEND_ORIGIN');
    if (backendOrigin) {
      baseUrl = backendOrigin;
    }
  }
  return baseUrl + '/wiki';
};

/**
 * @deprecated Access this from the BridgeData instead.
 */
export const setActivationId = (id: string | undefined) => {
  activationId = id;
};

/**
 * @deprecated Access this from the BridgeData instead.
 */
export const getActivationId = (): string | undefined => {
  if (activationId) {
    return activationId;
  }

  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get('activationId') ?? undefined;
  if (id) {
    activationId = id;
  }

  return id;
};

export const getConfluenceWorkspaceId = (): string => {
  const cloudId = getCloudId();
  const activationId = getActivationId();

  return cloudId && activationId
    ? `ari:cloud:confluence:${cloudId}:workspace/${activationId}`
    : '';
};

export const getJiraServers = async () => {
  const sites = await new DatasourceService('jira').getAvailableSites();
  return await Promise.all(
    sites.map(async (site) => {
      const { name, cloudId } = site;
      const id = await getServerIdFromCloudId(cloudId);
      return { id, name, cloudId };
    })
  );
};

export const getFocusedCommentContentId = (): string | undefined => {
  const parentQueryParams = new URLSearchParams(getParentWindow().location.search);
  const selfQueryParams = new URLSearchParams(window.location.search);

  if (parentQueryParams.has('focusedCommentId')) {
    return parentQueryParams.get('focusedCommentId') ?? undefined;
  }

  if (selfQueryParams.has('focusedCommentId')) {
    return selfQueryParams.get('focusedCommentId') ?? undefined;
  }

  if (parentQueryParams.has('replyToComment')) {
    return parentQueryParams.get('replyToComment') ?? undefined;
  }

  if (selfQueryParams.has('replyToComment')) {
    return selfQueryParams.get('replyToComment') ?? undefined;
  }

  return undefined;
};

export const getVersionId = (): string | undefined => {
  const parentQueryParams = new URLSearchParams(getParentWindow().location.search);
  const selfQueryParams = new URLSearchParams(window.location.search);

  if (parentQueryParams.has('version')) {
    return parentQueryParams.get('version') ?? undefined;
  }

  if (selfQueryParams.has('version')) {
    return selfQueryParams.get('version') ?? undefined;
  }

  return undefined;
};

export const getContentIdFromPath = (pathname: string) => {
  const pattern = /^\/wiki\/spaces\/([^/]+)\/([^/]+\/?[^/]*)\/(\d+)(\/.*)?$/;

  const match = pathname.match(pattern);
  if (match) {
    const contentId = decodeURIComponent(match[3]);
    return contentId;
  }

  // path won't match if not in confluence
  return null;
};

export const getContentIdFromQueryParams = (): string | undefined => {
  const queryParams = new URLSearchParams(getParentWindow().location.search);
  return queryParams.get('contentId') ?? undefined;
};
